import {
  applyReportFilterModel,
  normalizeColumnFilter,
} from '../../grid/filterUtils';
import { idsForSelectedNames } from '../../grid/storeLocationFilter';
import { isCompositeDispensingLocationLabel } from './controlledSubstanceDispensingLocationOptions';

function hasTextFilter(spec) {
  return spec && spec.filter != null && String(spec.filter).trim() !== '';
}

function uniqueStoreNames(names) {
  const seen = new Set();
  const out = [];
  (names || []).forEach((name) => {
    const trimmed = String(name).trim();
    if (!trimmed || seen.has(trimmed)) return;
    seen.add(trimmed);
    out.push(trimmed);
  });
  return out;
}

export function allStoreNamesResolveToIds(setNames, resolveStoreIds) {
  const names = uniqueStoreNames(setNames);
  if (!names.length) return false;
  return names.every((name) => resolveStoreIds('store', [name]).length > 0);
}

export function collectStoreIdsForNames(setNames, resolveStoreIds) {
  const ids = [];
  uniqueStoreNames(setNames).forEach((name) => {
    resolveStoreIds('store', [name]).forEach((id) => {
      if (!ids.includes(id)) ids.push(id);
    });
  });
  return ids;
}

/**
 * Store dropdown set-filters on dispensing_location must not AND an exact IN on the
 * composite SQL (store name only ≠ "Store – Kiosk"). Resolve to store_ids when
 * every selected name maps to an account id; otherwise filter accounts.name via
 * searchObject.store (existing API field). Free-text filters stay on
 * dispensing_location for ILIKE on the composite.
 */
function stripDispensingLocationSetValues(body) {
  if (!body || !body.searchObject || !body.searchObject.dispensing_location) {
    return;
  }
  const spec = body.searchObject.dispensing_location;
  if (!Array.isArray(spec.values) || !spec.values.length) {
    return;
  }
  const text = hasTextFilter(spec) ? String(spec.filter).trim() : '';
  if (text) {
    body.searchObject.dispensing_location = { filter: text };
  } else {
    delete body.searchObject.dispensing_location;
    if (!Object.keys(body.searchObject).length) {
      body.searchObject = null;
    }
  }
}

function applyStoreNameSetFallback(body, storeNames) {
  const names = uniqueStoreNames(storeNames);
  body.store_ids = [];
  body.searchObject = body.searchObject || {};
  delete body.searchObject.dispensing_location;
  if (!names.length) {
    if (body.searchObject && !Object.keys(body.searchObject).length) {
      body.searchObject = null;
    }
    return;
  }
  body.searchObject.store = { filterType: 'set', values: names };
}

/**
 * Controlled Substance Dispensed: date + column filters for SSRM / export payloads.
 */
export function applyControlledSubstanceReportFilterModel(
  body,
  filterModel,
  options = {}
) {
  const resolveStoreIds =
    options.idsForSelectedNames || idsForSelectedNames;

  applyReportFilterModel(body, filterModel, { dateColIds: ['pickupdate'] });

  const raw = filterModel && filterModel.dispensing_location;
  const normalized = raw ? normalizeColumnFilter(raw) : null;
  const setNames =
    normalized && Array.isArray(normalized.values)
      ? normalized.values.map((v) => String(v).trim()).filter(Boolean)
      : [];

  if (!setNames.length) {
    return body;
  }

  if (setNames.some(isCompositeDispensingLocationLabel)) {
    body.store_ids = [];
    return body;
  }

  if (allStoreNamesResolveToIds(setNames, resolveStoreIds)) {
    body.store_ids = collectStoreIdsForNames(setNames, resolveStoreIds);
    stripDispensingLocationSetValues(body);
    return body;
  }

  applyStoreNameSetFallback(body, setNames);
  return body;
}

export { stripDispensingLocationSetValues, applyStoreNameSetFallback };



// WEBPACK FOOTER //
// ./src/components/reports/controlled-substance-dispensed/controlledSubstanceReportFilterModel.js